import emptyReducer from './emptyReducer';

const toCheckboxesHave = (value: string) =>
  emptyReducer<boolean | undefined>(undefined).with({
    Checkboxes: (label, checkboxes) => checkboxes.find(checkbox => checkbox.label === value)?.checked,
  });

export default toCheckboxesHave;
